var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05127 0.789966C9.35836 -0.114831 10.6381 -0.11483 10.9452 0.789968L12.4649 5.26771C12.6026 5.6734 12.9835 5.9463 13.4119 5.9463H18.234C19.2133 5.9463 19.6089 7.20811 18.805 7.76726L14.98 10.4277C14.6141 10.6821 14.4608 11.148 14.604 11.57L16.0826 15.9263C16.3927 16.84 15.3568 17.6196 14.5646 17.0687L10.5692 14.2897C10.226 14.051 9.77045 14.051 9.42721 14.2897L5.43178 17.0687C4.63965 17.6196 3.60372 16.84 3.91384 15.9263L5.39241 11.57C5.53564 11.148 5.38232 10.6821 5.01646 10.4277L1.1914 7.76726C0.387481 7.20811 0.783142 5.9463 1.7624 5.9463H6.58453C7.01296 5.9463 7.39378 5.6734 7.53148 5.26771L9.05127 0.789966Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOrange);
export default __webpack_public_path__ + "static/media/star_orange.6144e1f758c0d947eabd8d91852ac214.svg";
export { ForwardRef as ReactComponent };